module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-13.e60a292e.png";